<template>
	<div class="con">
		<button class="down_load" @click="install">下载文件</button>
		<div id="pdfDom">
			<img src="../../static/img/piao1.png" />
		</div>
	</div>
	
</template>

<script>
	import html2Canvas from 'html2canvas'
	import JsPDF from 'jspdf'
	import Qs from 'qs'
	export default {
		data() {
			return {
				title: 'template',
			};
		},

		created() {},
		mounted() {
			
		},
		methods: {
			install() {
//				var c =document.createElement('canvas');
//				var dom= document.getElementById('pdfDom')
//		        var opts = {
//			        scale: 2, 
//			        canvas: c, 
//			        logging: true, 
//			        width: dom.clientWidth, 
//			        height: dom.clientHeight,
//			    };
//		       c.width = dom.clientWidth * 2
//		       c.height = dom.clientHeight * 2
//		       c.getContext("2d").scale(2, 2); 
				html2Canvas(document.getElementById('pdfDom')).then((canvas) => {
//					document.getElementById('home').appendChild(canvas)
					let contentWidth = canvas.width
					let contentHeight = canvas.height
					let pageHeight = contentWidth / 592.28 * 841.89
					let leftHeight = contentHeight
					let position = 0
					let imgWidth = 595.28
					let imgHeight = 592.28 / contentWidth * contentHeight
					let pageData = canvas.toDataURL('image/jpeg', 1.0)
					let PDF = new JsPDF('', 'pt', 'a4')
					if(leftHeight < pageHeight) {
						PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
					} else {
						while(leftHeight > 0) {
							PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
							leftHeight -= pageHeight
							position -= 841.89
							if(leftHeight > 0) {
								PDF.addPage()
							}
						}
					}
					PDF.save(this.title + '.pdf')
				})
			},
		}
	}
	
</script>

<style scoped>
	#pdfDom{
		width: 634px;
		height: 689px;
		margin: 0 auto;
	}
	.down_load{
		border: none;
		display:block;
		margin: 0 auto;
		text-align: center;
		color: #fff;
		font-size: 16px;
		line-height: 40px;
		width: 166px;
		height: 40px;
		border-radius: 4px;
		background: rgba(24, 144, 255, 1) url(../../static/img/up.png) no-repeat 13px 13px;
		background-size: 14px 14px;
	}
</style>


// WEBPACK FOOTER //
// src/components/PiaoTemplate.vue